'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_DashboardView$$anon$24() {
  this.aLB = null;
  this.aLC = false;
}
export { $c_Lpresto_DashboardView$$anon$24 as $c_Lpresto_DashboardView$$anon$24 };
$p = $c_Lpresto_DashboardView$$anon$24.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_DashboardView$$anon$24;
/** @constructor */
function $h_Lpresto_DashboardView$$anon$24() {
}
export { $h_Lpresto_DashboardView$$anon$24 as $h_Lpresto_DashboardView$$anon$24 };
$h_Lpresto_DashboardView$$anon$24.prototype = $p;
$p.P = (function() {
  if ((!this.aLC)) {
    this.aLB = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T2($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.aLC = true;
  }
  return this.aLB;
});
var $d_Lpresto_DashboardView$$anon$24 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_DashboardView$$anon$24, "presto.DashboardView$$anon$24", ({
  GY: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_DashboardView$$anon$24 as $d_Lpresto_DashboardView$$anon$24 };
//# sourceMappingURL=presto.-Dashboard-View$$anon$24.js.map
